import styled from 'styled-components'
import { Card , } from 'antd'

export const StyledCard = styled(Card)`
  input { 
    max-width: 100px;
  }
`


// WEBPACK FOOTER //
// ./src/components/table-risk-selected/style.js